export default class Progress {

    static initializeEvents() {
        const progressBar = document.getElementById('progress-bar');
        const followSection = document.querySelector(".follow");
        const footer = document.querySelector("footer");
        const summary = document.querySelector(".summary-sticky");
        const progress = document.querySelector(".progress");

        if (progress && summary && summary.contains(progress)) {
            progress.style.position = "relative";
            progress.style.marginTop = "-16px"
            progress.style.marginBottom = "8px"
        }

        if (progressBar) {
            window.onscroll = function () {
                let scrollTop = document.documentElement.scrollTop;
                let scrollHeight;

                if (followSection) {
                    let followTop = followSection.offsetTop;
                    scrollHeight = followTop - window.innerHeight;
                } else if (footer) {
                    let footerTop = footer.offsetTop;
                    scrollHeight = footerTop - window.innerHeight;
                } else {
                    scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
                }

                let progress = (scrollTop / scrollHeight) * 100;
                progressBar.style.width = Math.min(progress, 100) + "%";
            };
        }
    }

}